/* Rethryv — motion & nav behavior.
   Loaded globally. Keeps things slow and few; honors reduced-motion. */
(function () {
  'use strict';

  function init() {
    var nav = document.querySelector('[data-rethryv-nav]');
    var hasHero = !!document.querySelector('[data-rethryv-hero]');

    // Nav: transparent over a dark hero, solid otherwise.
    if (nav) {
      if (!hasHero) nav.classList.add('is-solid');
      var onScroll = function () {
        if (hasHero) nav.classList.toggle('is-solid', window.scrollY > 60);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    // Mobile menu toggle
    var toggle = document.querySelector('[data-rethryv-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        document.body.classList.toggle('nav-open');
        toggle.setAttribute('aria-expanded', document.body.classList.contains('nav-open') ? 'true' : 'false');
      });
      document.querySelectorAll('.nav__mobile a').forEach(function (a) {
        a.addEventListener('click', function () { document.body.classList.remove('nav-open'); });
      });
    }

    // Two-routes switch (always active, incl. theme editor)
    document.querySelectorAll('[data-route-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var route = tab.getAttribute('data-route-tab');
        var root = tab.closest('[data-routes]') || document;
        root.querySelectorAll('[data-route-tab]').forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
        });
        root.querySelectorAll('[data-route-panel]').forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-route-panel') === route);
        });
      });
    });

    // Buy-box option selector (Subscribe & Save vs one-time)
    document.querySelectorAll('.buy__options').forEach(function (group) {
      var opts = group.querySelectorAll('.buy__option');
      var form = group.closest('form');
      var planField = form && form.querySelector('[data-buy-plan]');

      // Subscribe and one-time sit in the same list, so the chosen row has to
      // carry both the variant and, when it is the subscribe row, the plan.
      var subNote = form && form.querySelector('[data-buy-subnote]');
      function applyPlan(radio) {
        if (!radio) return;
        var plan = radio.getAttribute('data-plan') || '';
        if (planField) planField.value = plan;
        // the "what actually arrives" note belongs to the subscribe row only
        if (subNote) subNote.hidden = !plan;
      }

      opts.forEach(function (opt) {
        opt.addEventListener('click', function () {
          opts.forEach(function (o) { o.classList.remove('is-active'); });
          opt.classList.add('is-active');
          var radio = opt.querySelector('input[type="radio"]');
          if (radio) {
            radio.checked = true;
            applyPlan(radio);
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });

      applyPlan(group.querySelector('input[type="radio"]:checked'));
    });

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var inEditor = window.Shopify && window.Shopify.designMode;

    // Count-up numbers
    var counts = document.querySelectorAll('[data-count]');
    function countUp(el) {
      var target = parseFloat(el.getAttribute('data-count'));
      if (reduced) { el.textContent = target; return; }
      var dur = 1100, t0 = null;
      function tick(now) {
        if (t0 === null) t0 = now;
        var p = Math.min(1, (now - t0) / dur);
        el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    // Reveal + count: reveal immediately in editor / reduced-motion / no IO.
    var targets = document.querySelectorAll('[data-reveal]');
    if (reduced || inEditor || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      counts.forEach(function (el) { el.textContent = el.getAttribute('data-count'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el) { io.observe(el); });

    var countIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { countUp(e.target); countIo.unobserve(e.target); }
      });
    }, { threshold: 0.6 });
    counts.forEach(function (el) { countIo.observe(el); });

    // ---- PDP gallery ------------------------------------------------------
    document.querySelectorAll('[data-pdp-thumbs]').forEach(function (strip) {
      var media = strip.closest('.pdp__media');
      var main = media && media.querySelector('[data-pdp-main]');
      if (!main) return;
      strip.querySelectorAll('[data-pdp-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          main.src = btn.getAttribute('data-pdp-thumb');
          main.alt = btn.getAttribute('data-pdp-alt') || '';
          strip.querySelectorAll('[data-pdp-thumb]').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
        });
      });
    });

    // ---- Qualify questionnaire -------------------------------------------
    // Progressive enhancement: without JS every step is visible and the form
    // still submits. With JS it becomes one question at a time.
    document.querySelectorAll('[data-qz]').forEach(function (qz) {
      var steps = Array.prototype.slice.call(qz.querySelectorAll('[data-qz-step]'));
      if (!steps.length) return;
      var fill  = qz.querySelector('[data-qz-fill]');
      var count = qz.querySelector('[data-qz-count]');
      var at = 0;

      qz.classList.add('is-stepped');

      function answered(step) {
        // the details step relies on native validation instead
        if (!step.querySelector('.qz__opts')) return true;
        return !!step.querySelector('input:checked');
      }

      function show(i) {
        at = Math.max(0, Math.min(i, steps.length - 1));
        steps.forEach(function (s, n) { s.classList.toggle('is-on', n === at); });
        var pct = ((at + 1) / steps.length) * 100;
        if (fill) fill.style.width = pct + '%';
        if (count) count.textContent = 'Step ' + (at + 1) + ' of ' + steps.length;
        var back = steps[at].querySelector('[data-qz-back]');
        if (back) back.style.visibility = at === 0 ? 'hidden' : 'visible';
        sync(steps[at]);
        var legend = steps[at].querySelector('.qz__q');
        if (legend) legend.setAttribute('tabindex', '-1');
        if (legend && at > 0) legend.focus({ preventScroll: true });
      }

      function sync(step) {
        var next = step.querySelector('[data-qz-next]');
        if (next && next.type !== 'submit') next.disabled = !answered(step);
      }

      // multi-select answers get joined into the hidden contact[...] field
      qz.querySelectorAll('[data-qz-multi]').forEach(function (box) {
        box.addEventListener('change', function () {
          var key = box.getAttribute('data-qz-multi');
          var picked = [];
          qz.querySelectorAll('[data-qz-multi="' + key + '"]:checked').forEach(function (b) {
            picked.push(b.value);
          });
          var store = qz.querySelector('[data-qz-store="' + key + '"]');
          if (store) store.value = picked.join(', ');
          sync(box.closest('[data-qz-step]'));
        });
      });

      var reducedQ = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      qz.querySelectorAll('[data-qz-single]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          var step = radio.closest('[data-qz-step]');
          sync(step);
          // one tap, one answer: move on rather than making them find Continue
          if (steps.indexOf(step) === at) {
            window.setTimeout(function () { show(at + 1); }, reducedQ ? 0 : 260);
          }
        });
      });

      qz.querySelectorAll('[data-qz-next]').forEach(function (b) {
        b.addEventListener('click', function () { show(at + 1); });
      });
      qz.querySelectorAll('[data-qz-back]').forEach(function (b) {
        b.addEventListener('click', function () { show(at - 1); });
      });

      show(0);

      // Post answers to the CRM, then let the native form submit so the email
      // copy still lands. If the webhook is slow or down we submit anyway
      // rather than lose the lead.
      var hook = qz.getAttribute('data-qz-hook');
      var form = qz.closest('form');
      if (hook && form) {
        form.addEventListener('submit', function (ev) {
          if (form.getAttribute('data-qz-sent')) return;
          var hp = form.querySelector('[data-qz-hp]');
          if (hp && hp.value) { ev.preventDefault(); return; }
          ev.preventDefault();

          var first = form.querySelector('[data-qz-first]');
          var last = form.querySelector('[data-qz-last]');
          var full = form.querySelector('[data-qz-fullname]');
          if (full) full.value = ((first ? first.value : '') + ' ' + (last ? last.value : '')).trim();

          var payload = { source: 'Rethryv website', page: window.location.href };
          form.querySelectorAll('[name^="contact["]').forEach(function (f) {
            if (f.type === 'radio' && !f.checked) return;
            var key = f.name.slice(8, -1);
            if (f.value) payload[key] = f.value;
          });
          // GHL maps first_name / last_name automatically
          payload.first_name = payload['First name'] || '';
          payload.last_name = payload['Last name'] || '';
          payload.name = (payload.first_name + ' ' + payload.last_name).trim();

          var go = function () {
            if (form.getAttribute('data-qz-sent')) return;
            form.setAttribute('data-qz-sent', '1');
            form.submit();
          };
          window.setTimeout(go, 2500);
          try {
            fetch(hook, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(payload),
              keepalive: true
            }).then(go, go);
          } catch (err) { go(); }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
